import {
  createSlice,
  createEntityAdapter,
  createSelector,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'state/store';
import { ProgramSummary } from 'types/store/normalized/programSummary';

const programsAdapter = createEntityAdapter<ProgramSummary>();
const initialState = programsAdapter.getInitialState();

const programsSlice = createSlice({
  name: 'projectsList/include/programs',
  initialState,
  reducers: {
    updatePrograms: (
      state,
      action: PayloadAction<{
        programs: ProgramSummary[];
        shouldReplace: boolean;
      }>
    ) => {
      const { programs, shouldReplace } = action.payload;
      if (shouldReplace) {
        programsAdapter.setAll(state, programs);
      } else {
        programsAdapter.upsertMany(state, programs);
      }
    },
    removeAllPrograms: (state) => {
      programsAdapter.removeAll(state);
    },
  },
});

export const { updatePrograms, removeAllPrograms } = programsSlice.actions;

const selectPrograms = (state: RootState) =>
  state.projectsList.include.programs;

export const { selectAll: selectAllPrograms } =
  programsAdapter.getSelectors<RootState>(selectPrograms);

export const selectProgramsById = createSelector(
  [selectAllPrograms, (_, programIds: string[]) => programIds],
  (programs, programIds) =>
    programs.filter((program) => programIds.includes(program.id))
);

export default programsSlice.reducer;
